import mapActions from './mapActions';

export default mapActions('group_history', {
    fetchAll_url: () => '/api/employees/group_history'
});
